/* eslint-disable @typescript-eslint/no-namespace */
import _ from 'lodash';

export namespace MapperHelpers {
  export interface PropMappers<T, U, Y> {
    getProperty: (item: T) => U[];
    getArrayProperty: (item: U[]) => Y[];
  }

  export interface SortMappers<T, X> {
    sortBy: (item: T) => X;
  }

  export interface UniqMappers<T, X> {
    uniqBy: (item: T) => X;
  }

  export interface Mappers<T, U, Y, X>
    extends PropMappers<T, U, Y>,
      SortMappers<Y, X>,
      UniqMappers<Y, X> {}

  export function getItemPropertiesFromArray<T, U, Y>(
    array: T[],
    mappers: PropMappers<T, U, Y>
  ): Y[] {
    return array.reduce(
      (prev, item: T) => [
        ...prev,
        ...mappers.getArrayProperty(mappers.getProperty(item)),
      ],
      []
    );
  }

  export function getUniqItemPropertiesFromArray<T, U, Y, X>(
    array: T[],
    mappers: PropMappers<T, U, Y> & UniqMappers<Y, X>
  ) {
    return _.uniqBy(getItemPropertiesFromArray(array, mappers), mappers.uniqBy);
  }

  export function getSortedItemPropertiesFromArray<T, U, Y, X>(
    array: T[],
    mappers: PropMappers<T, U, Y> & SortMappers<Y, X>
  ) {
    return _.sortBy(getItemPropertiesFromArray(array, mappers), mappers.sortBy);
  }

  export function getUniqSortedItemPropertiesFromArray<T, U, Y, X>(
    array: T[],
    mappers: Mappers<T, U, Y, X>
  ) {
    return _.sortBy(
      _.uniqBy(getItemPropertiesFromArray(array, mappers), mappers.uniqBy),
      mappers.sortBy
    );
  }
}
